import { render, staticRenderFns } from "./opname.vue?vue&type=template&id=a1d8f410"
import script from "./opname.vue?vue&type=script&lang=js"
export * from "./opname.vue?vue&type=script&lang=js"
import style0 from "./opname.vue?vue&type=style&index=0&id=a1d8f410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports